(function () {

    function injectGoKwikStyles() {

        const host = document.querySelector("shadow-dom-container");

        if (!host || !host.shadowRoot) return;

        const root = host.shadowRoot;

        /* Prevent duplicate injection */
        if (root.getElementById("cc-gokwik-style")) return;

        const style = document.createElement("style");

        style.id = "cc-gokwik-style";

        style.textContent = `

            /* =====================================================
               GOKWIK ADD BUTTON
               ===================================================== */

            .add-btn {
                border: 1.5px solid #ED1B24 !important;
                color: #ED1B24 !important;
                background: #FFFFFF !important;
                border-radius: 8px !important;
                font-weight: 500 !important;
                transition: all .25s ease;
            }

            .add-btn:hover {
                background: #ED1B24 !important;
                color: #FFFFFF !important;
            }


            /* =====================================================
               GOKWIK PROGRESS TEXT
               ===================================================== */

            .next-milestone-text {
                color: #16A34A !important;
                font-weight: 600 !important;
            }


            /* =====================================================
               MOBILE CART LAYOUT
               Keep the checkout area compact.
               ===================================================== */

            @media screen and (max-width: 767px) {

                /*
                 * Prevent the sticky checkout area from becoming
                 * excessively tall.
                 */
                button {
                    max-height: none;
                }

            }

        `;

        root.appendChild(style);

        /*
         * Give the cart's scrollable area enough room
         * to scroll completely above the sticky checkout.
         */
        requestAnimationFrame(function () {
            fixCartScrollSpace(root);
        });

    }


    function fixCartScrollSpace(root) {

        /*
         * Find the Checkout button inside GoKwik's Shadow DOM.
         */
        const elements = Array.from(root.querySelectorAll('*'));

        const checkoutButton = elements.find(function (el) {

            const text = (el.textContent || '')
                .trim()
                .replace(/\s+/g, ' ')
                .toLowerCase();

            return (
                el.tagName === 'BUTTON' &&
                text === 'checkout'
            );

        });

        if (!checkoutButton) return;


        /*
         * Walk upward until we find the sticky/fixed
         * checkout container.
         */
        let checkoutContainer = checkoutButton.parentElement;

        let attempts = 0;

        while (
            checkoutContainer &&
            checkoutContainer.parentElement &&
            attempts < 8
        ) {

            const styles = window.getComputedStyle(checkoutContainer);

            const position = styles.position;

            if (
                position === 'fixed' ||
                position === 'sticky'
            ) {
                break;
            }

            checkoutContainer = checkoutContainer.parentElement;

            attempts++;
        }


        if (!checkoutContainer) return;


        /*
         * Measure the actual checkout area.
         */
        const footerHeight =
            checkoutContainer.getBoundingClientRect().height;


        if (!footerHeight || footerHeight < 40) return;


        /*
         * Find the nearest scrollable parent.
         */
        let scrollContainer = checkoutContainer.previousElementSibling;

        if (!scrollContainer) {
            scrollContainer = checkoutContainer.parentElement;
        }


        /*
         * Walk upward until we find the actual
         * scrollable container.
         */
        let current = scrollContainer;

        for (let i = 0; i < 8 && current; i++) {

            const styles = window.getComputedStyle(current);

            const isScrollable =
                /(auto|scroll)/.test(styles.overflowY) &&
                current.scrollHeight > current.clientHeight;

            if (isScrollable) {
                scrollContainer = current;
                break;
            }

            current = current.parentElement;
        }


        if (!scrollContainer) return;


        /*
         * IMPORTANT:
         *
         * Add enough bottom space so the final upsell
         * products can scroll completely above the
         * checkout panel.
         */
        scrollContainer.style.paddingBottom =
            Math.ceil(footerHeight + 24) + 'px';

        scrollContainer.style.boxSizing = 'border-box';

    }


    /*
     * Watch for GoKwik loading/re-rendering.
     */
    const observer = new MutationObserver(function () {

        injectGoKwikStyles();

    });


    observer.observe(document.documentElement, {

        childList: true,
        subtree: true

    });


    /*
     * Initial attempt.
     */
    injectGoKwikStyles();


    /*
     * Re-check after the cart has had time to render.
     */
    setTimeout(injectGoKwikStyles, 500);
    setTimeout(injectGoKwikStyles, 1500);
    setTimeout(injectGoKwikStyles, 3000);

})();